var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_94_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.88087 2.68726L1.07744 11.4913C1.03315 11.5357 1.00117 11.5918 0.985939 11.6521L0.0101637 15.5687C-0.0190245 15.6866 0.0156207 15.8119 0.101663 15.898C0.166765 15.9631 0.255472 15.9991 0.346209 15.9991C0.374002 15.9991 0.402428 15.9957 0.430094 15.9887L4.34665 15.0128C4.40769 14.9976 4.46315 14.9657 4.50744 14.9214L13.3116 6.11802L9.88087 2.68726Z",
    fill: "#2468FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4924 1.48706L14.5124 0.507094C13.8574 -0.147864 12.7159 -0.14723 12.0617 0.507094L10.8613 1.70749L14.292 5.13813L15.4924 3.93773C15.8195 3.61069 15.9997 3.17541 15.9997 2.71246C15.9997 2.24951 15.8195 1.81422 15.4924 1.48706Z",
    fill: "#2468FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_94_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit1);
export default __webpack_public_path__ + "static/media/edit 1.0af86a8b.svg";
export { ForwardRef as ReactComponent };